function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import find from 'ramda/src/find';
import isNil from 'ramda/src/isNil';
import map from 'ramda/src/map';
import pathOr from 'ramda/src/pathOr';
import pipe from 'ramda/src/pipe';
import propEq from 'ramda/src/propEq';
import propOr from 'ramda/src/propOr';
import reject from 'ramda/src/reject';
import LocaleKeys from '../../../locales/keys';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../customer/ewallet/ewallet.constants';
import { CoreLocaleKeys, CreditCardFieldNames, i18n, FormHelper, MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import { createAddress, retrieveCustomerAddresses, setAddressData, updateAddress } from '../../../reducers/actions/customer.addresses.actions';
import { PostalCodeSelector } from '../../../reducers/selectors/customer.addresses.selectors';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { ExternalBillTypesSelector, IsAccountNumberEnabledSelector, PaymentInstrumentTypeErrorsSelector, PaymentInstrumentTypeValueOptions, SelectedPaymentTypeRequiresAddress, SubscriberExternalGiftCardTypeOptionsWithRegexes } from '../../../reducers/selectors/modify.payment.method.popup.selectors';
import { EditAddressPopupStateRegionProvinceValueOptions, MakePaymentAddressSelector, MakePaymentAddressesSelector } from '../../customer/makePayment/make.payment.selectors';
import { setMakePaymentInstrumentBillingAddress, setMakePaymentAddressStateValue, setMakePaymentInstrument } from '../../../reducers/actions/make.payment.actions';
import { createPaymentInstrument, editPaymentInstrument, redeemGiftCard, setRecordPaymentInstrument } from '../../../reducers/actions/customer.ewallet.actions';
import { fetchCodeTypesFromConfiguration } from 'invision-core/src/components/metadata/codes/codes.actions';
import { EwalletErrorsSelector, NewPaymentMethodWithTypeNamesAndMetadataViewModelSelector, PaymentInstrumentTypeValueOptionsWithAutoPay, PaymentIsCreatingOrEditingDataSelector } from '../../../reducers/selectors/customer.ewallet.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../customercare.constants';
import { BLANK_PAYMENT_INSTRUMENT, NO_FORM_ERRORS } from '../../customer/makePayment/make.payment.constants';
import { addressStateRegionProvinceValueOptionsForCountry } from '../../../reducers/helpers/customer.selectors.helpers';
import { buildPaymentInstrumentRequest } from '../../paymentBillingAddressForm/payment.billing.address.form.helper';
import { parseAdditionalProperties, PaymentInstrumentConfigurationAdditionalProperties, paymentInstrumentConfigurationAdditionalPropertyDescriptors } from '../../../reducers/helpers/payment.instrument.additional.property.parser';
import { ADDRESS_FORM_FIELD_MAX_LENGTH } from '../../customer/addresses/addresses.constants';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../reducers/actions/address.component.actions';
import { stateRequiredHelper } from '../../customer/addresses/address.helper';
var BILLING_ADDRESS_ERRORS_KEY = 'BILLING_ADDRESS_ERRORS_KEY';
var ENTER_KEY = 13;
export var ModifyPaymentMethodPopupController = /*#__PURE__*/function () {
  function ModifyPaymentMethodPopupController($ngRedux, uiNotificationService, $timeout) {
    _classCallCheck(this, ModifyPaymentMethodPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      addressFormModel: {},
      uiNotificationService: uiNotificationService,
      editPaymentInstrument: clone(BLANK_PAYMENT_INSTRUMENT),
      formErrors: NO_FORM_ERRORS,
      savePaymentInstrument: true,
      formNameMap: new Map([[SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD, 'creditCardController.creditCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD, 'giftCardController.giftCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD, 'externalGiftCardController.externalGiftCardForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL, '$ctrl.externalBillForm'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK, 'eCheckController.echeckForm']]),
      CHANGE_CARD_TYPE: 'cardType',
      objectAttributeMap: new Map([[SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD, 'CreditCard'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD, 'ExternalGiftCard'], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK, 'ECheck']]),
      paymentInstrumentAttributes: ['BillingAddress', 'BillingAddressId', 'Id', 'Name', 'Type'],
      instrumentAttributesToKeep: [],
      errorsMap: new Map([[SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CreditCardFieldNames.CC_NUMBER, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.CARD_NUMBER_REQUIRED)
      }), CreditCardFieldNames.CC_TYPE, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.CARD_TYPE_REQUIRED)
      }), CreditCardFieldNames.CC_CVV, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.CVV_REQUIRED)
      }), CreditCardFieldNames.CC_EXP_MONTH, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXPIRATION_MONTH_REQUIRED)
      }), CreditCardFieldNames.CC_EXP_YEAR, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXPIRATION_YEAR_REQUIRED)
      }), CreditCardFieldNames.CC_NAME, {
        required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.NAME_ON_CARD_REQUIRED)
      })], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD, {
        cardPin: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.GIFT_CARD_PIN_REQUIRED)
        }
      }], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD, {
        accountNumber: {
          pattern: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_GIFT_CARD.ACCOUNT_NUMBER_INVALID_PATTERN),
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_GIFT_CARD.ACCOUNT_NUMBER_REQUIRED)
        },
        authKey: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_GIFT_CARD.AUTH_KEY_REQUIRED)
        },
        cardType: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_GIFT_CARD.CARD_TYPE_REQUIRED)
        }
      }], [SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL, {
        accountNumber: {
          pattern: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.ACCOUNT_NUMBER_INVALID_PATTERN),
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.ACCOUNT_NUMBER_REQUIRED)
        },
        authorizationChallenge: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.AUTHORIZATION_CHALLENGE_REQUIRED)
        },
        nameOnAccount: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.NAME_ON_ACCOUNT_REQUIRED)
        },
        phoneNumber: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.PHONE_NUMBER_REQUIRED)
        },
        expiration: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.EXTERNAL_BILL.EXPIRATION_INVALID_DATE)
        }
      }], [BILLING_ADDRESS_ERRORS_KEY, {
        address_line_1: {
          required: i18n.translate(LocaleKeys.ADDRESS_LINE_1_REQUIRED)
        },
        city: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.CITY_REQUIRED)
        },
        country: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.COUNTRY_REQUIRED)
        },
        postal_code: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.POSTAL_CODE_REQUIRED)
        },
        state_region_province: {
          required: i18n.translate(LocaleKeys.MAKE_PAYMENT.ERRORS.STATE_REGION_PROVINCE_REQUIRED)
        }
      }]]),
      onAddressFormChanged: this.onAddressFormChanged.bind(this)
    });
  }
  return _createClass(ModifyPaymentMethodPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.CoreLocaleKeys = CoreLocaleKeys;
      this.LocaleKeys = LocaleKeys;
      this.PaymentTypes = SUPPORTED_PAYMENT_INSTRUMENT_TYPES;
      this.resetStateFlag = true;
      this.loadingIndicator = false;
      this.savePaymentInstrument = true;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressCountriesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressCountry, store),
          addressCountriesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressCountry, store),
          addressCountriesOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.AddressCountry, store),
          addressRequirements: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressRequirements, store),
          addressRequirementsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressRequirements, store),
          addressStatesAll: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
          addressStatesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.AddressStateProvinceRegion, store),
          addressStatesOptions: EditAddressPopupStateRegionProvinceValueOptions(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          creditCardTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.CreditCardType, store),
          eWalletError: EwalletErrorsSelector(store),
          externalBillTypes: ExternalBillTypesSelector(store),
          externalBillTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalBillType, store),
          externalGiftCardTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalGiftCardType, store),
          externalGiftCardTypes: SubscriberExternalGiftCardTypeOptionsWithRegexes(store),
          giftCardConfigurationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.GiftCardConfiguration, store),
          isAccountNumberEnabled: IsAccountNumberEnabledSelector(store),
          isCreatingOrEditingData: PaymentIsCreatingOrEditingDataSelector(store),
          makePaymentAddress: MakePaymentAddressSelector(store),
          makePaymentAddresses: MakePaymentAddressesSelector(store),
          newPaymentMethodWithMetadata: NewPaymentMethodWithTypeNamesAndMetadataViewModelSelector(store),
          paymentInstrumentConfiguration: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
          paymentInstrumentConfigurationLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PaymentInstrumentConfiguration, store),
          paymentInstrumentTypes: PaymentInstrumentTypeValueOptions(store),
          paymentInstrumentTypesErrors: PaymentInstrumentTypeErrorsSelector(store),
          paymentInstrumentAutoPayTypes: PaymentInstrumentTypeValueOptionsWithAutoPay(store),
          paymentInstrumentTypeLoaded: MetadataSelectors.codes.PaymentInstrumentTypeLoadedSelector(store),
          paymentTypeRequiresAddress: SelectedPaymentTypeRequiresAddress(store),
          postalCode: PostalCodeSelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store)
        };
      };
      var controllerActions = {
        createAddress: createAddress,
        createPaymentInstrument: createPaymentInstrument,
        editPaymentInstrument: editPaymentInstrument,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        fetchCodeTypesFromConfiguration: fetchCodeTypesFromConfiguration,
        redeemGiftCard: redeemGiftCard,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        setAddressData: setAddressData,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        setMakePaymentAddressStateValue: setMakePaymentAddressStateValue,
        setMakePaymentInstrumentBillingAddress: setMakePaymentInstrumentBillingAddress,
        setMakePaymentInstrument: setMakePaymentInstrument,
        setRecordPaymentInstrument: setRecordPaymentInstrument,
        updateAddress: updateAddress,
        validateAddress: validateAddress
      };
      this.formMaxLengthValidation = ADDRESS_FORM_FIELD_MAX_LENGTH;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.addressCountriesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AddressCountry);
      }
      if (!this.state.addressStatesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AddressStateProvinceRegion);
      }
      if (!this.state.creditCardTypes.length) {
        this.actions.fetchCodeType(MetadataConstants.codes.CreditCardType);
      }
      if (!this.state.paymentInstrumentTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentType);
      }
      if (!this.state.addressRequirementsLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.AddressRequirements);
      }
      if (!this.state.externalBillTypesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.ExternalBillType);
      }
      if (!this.state.externalGiftCardTypesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.ExternalGiftCardType);
      }
      if (!this.state.paymentInstrumentConfigurationLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.PaymentInstrumentConfiguration);
      }
      if (!this.state.giftCardConfigurationLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.GiftCardConfiguration);
      }
      this.retrieveCustomerAddresses = function () {
        _this.actions.retrieveCustomerAddresses(_this.state.currentCustomerId, true);
      };
      this.retrieveCustomerAddresses();
      this.getErrorLookupObject = function (typeCode) {
        return _this.errorsMap.get(typeCode) || {};
      };
      var setUpDialogKeys = function setUpDialogKeys() {
        _this.dialogTextKeys = {
          edit: {
            title: _this.LocaleKeys.MAKE_PAYMENT.EDIT_PAYMENT_TITLE,
            callToAction: _this.LocaleKeys.MAKE_PAYMENT.EDIT_PAYMENT_BUTTON
          },
          new: {
            title: _this.LocaleKeys.MAKE_PAYMENT.ADD_NEW_PAYMENT_METHOD,
            callToAction: _this.LocaleKeys.MAKE_PAYMENT.ADD_METHOD
          }
        };
      };
      this.errorLookup = this.getErrorLookupObject(this.editPaymentInstrument.Type);
      setUpDialogKeys();
      this.executeNewEditPaymentMethod = function () {
        _this.paymentInstrumentForm.$submitted = true;
        _this.paymentInstrumentForm.highlightErrorMessages();
        if (_this.paymentInstrumentForm.$valid) {
          var addressKey = _this.getAddressKey();
          _this.validateAddressWithAPI(addressKey).then(function () {
            var validatedAddress = _this.state.validatedAddresses[addressKey];
            if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
              _this.formErrors = NO_FORM_ERRORS;
              var requestData = {
                paymentTypeRequiresAddress: _this.state.paymentTypeRequiresAddress,
                editPaymentInstrument: _this.editPaymentInstrument,
                makePaymentAddress: _this.state.makePaymentAddress,
                creditCardTypes: _this.state.creditCardTypes,
                externalBillTypes: _this.state.externalBillTypes,
                externalGiftCardTypes: _this.state.externalGiftCardTypes,
                paymentInstrumentTypes: _this.state.paymentInstrumentTypes,
                currentCustomerId: _this.state.currentCustomerId
              };
              _this.isEditingPaymentInstrument ? _this.editPaymentMethod(requestData) : _this.addPaymentMethod(requestData);
            } else {
              _this.actions.setForceShowEditFormAddress(false);
              _this.uiNotificationService.transientError(i18n.translate(_this.LocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
            }
          }).catch(function (err) {
            _this.uiNotificationService.transientError(err.translatedMessage);
          });
        } else {
          _this.checkForErrors();
        }
      };
      this.submitIfEnter = function (event) {
        if (event.which === ENTER_KEY) {
          event.preventDefault();
          _this.executeNewEditPaymentMethod();
        }
      };
      this.addPaymentMethod = function (requestData) {
        if (_this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.INTERNAL_GIFT_CARD) {
          _this.actions.redeemGiftCard(_this.editPaymentInstrument.GiftCard.pin, _this.state.currentCustomerId, _this.editPaymentInstrument.GiftCard.accountNumber).then(function (redeemedGiftCard) {
            _this.onSuccessfulSubmit(i18n.translate(LocaleKeys.E_WALLET.REDEEM_GIFT_CARD_SUCCESS), redeemedGiftCard.GiftCard);
          });
        } else if (_this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD) {
          if (!_this.savePaymentInstrument) {
            return _this.onSuccessfulSubmit(i18n.translate(LocaleKeys.MAKE_PAYMENT.CREATE_INSTRUMENT_SUCCESS), buildPaymentInstrumentRequest(true, requestData, _this.savePaymentInstrument).request.PaymentInstrument, false);
          } else {
            return _this.actions.createPaymentInstrument(buildPaymentInstrumentRequest(true, requestData)).then(function (createdPaymentInstrument) {
              _this.onSuccessfulSubmit(i18n.translate(LocaleKeys.MAKE_PAYMENT.CREATE_INSTRUMENT_SUCCESS), createdPaymentInstrument.PaymentInstrument);
            }).catch(function (error) {
              _this.uiNotificationService.transientError(error.translatedMessage);
            });
          }
        }
      };
      this.handleSavePaymentInstrumentChanged = function () {
        _this.actions.setRecordPaymentInstrument(_this.savePaymentInstrument);
      };
      this.editPaymentMethod = function (requestData) {
        return _this.actions.editPaymentInstrument(buildPaymentInstrumentRequest(false, requestData)).then(function (editedPaymentInstrument) {
          _this.onSuccessfulSubmit(i18n.translate(LocaleKeys.MAKE_PAYMENT.EDIT_INSTRUMENT_SUCCESS), editedPaymentInstrument.PaymentInstrument);
        });
      };
      this.onSuccessfulSubmit = function (successMessageToToast, rawPaymentInstrumentForCallback) {
        var showToast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        _this.retrieveCustomerAddresses();
        if (showToast) {
          _this.uiNotificationService.success(successMessageToToast, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }
        if (rawPaymentInstrumentForCallback.CreditCard && _this.savePaymentInstrument) {
          delete rawPaymentInstrumentForCallback.CreditCard.Cvv;
        }
        _this.resetForm();
        _this.onSuccess()(rawPaymentInstrumentForCallback);
      };
      this.checkForErrors = function () {
        _this.gatherAndSetFormErrors();
        return _this.formErrors.length > 0;
      };
      this.resetForm = function () {
        _this.editPaymentInstrument = clone(BLANK_PAYMENT_INSTRUMENT);
        _this.addressFormModel = {};
        if (_this.paymentInstrumentForm) {
          _this.paymentInstrumentForm.$setPristine();
          _this.paymentInstrumentForm.$setUntouched();
        }
        _this.formErrors = NO_FORM_ERRORS;
      };
      this.gatherAndSetFormErrors = function () {
        //the payment method for errors have to be gathered by accessing the sub ng-forms
        var formName = _this.formNameMap.get(_this.editPaymentInstrument.Type);
        var formCardErrors = FormHelper.formHasErrors(_this.paymentInstrumentForm[formName].$error, _this.getErrorLookupObject(_this.editPaymentInstrument.Type));
        var paymentInstrumentFormClone = clone(_this.paymentInstrumentForm.$error);
        var billingErrors = FormHelper.formHasErrors(paymentInstrumentFormClone, _this.getErrorLookupObject(BILLING_ADDRESS_ERRORS_KEY));

        //we need to filter out descriptions that are blank from the error list FormHelper returns
        _this.formErrors = formCardErrors.concat(billingErrors).filter(function (message) {
          return !!message.description;
        });
      };
      this.getErrorMessageForBillingAddressField = function (formField) {
        var errorsForField = [];
        var formFieldErrorLookup = _this.getErrorLookupObject(BILLING_ADDRESS_ERRORS_KEY)[formField.$name];
        Object.keys(formField.$error).forEach(function (errorKey) {
          errorsForField.push(formFieldErrorLookup[errorKey]);
        });
        return errorsForField;
      };
      this.shouldShowNewEditLoading = function () {
        return _this.state.isCreatingOrEditingData || _this.loadingIndicator;
      };
      this.showHeaderErrorMessages = function () {
        return !_this.paymentInstrumentForm.$submitted && _this.state.paymentInstrumentTypesErrors && _this.state.paymentInstrumentTypesErrors.length > 0;
      };
      this.transformAdditionalProperties = function (additionalProperty) {
        var baseObject = new PaymentInstrumentConfigurationAdditionalProperties();
        return parseAdditionalProperties(baseObject, additionalProperty.AdditionalProperties, paymentInstrumentConfigurationAdditionalPropertyDescriptors);
      };
      this.shouldRequirePhoneNumber = function (instrumentType) {
        return pipe(reject(propEq(true, 'Global')), map(_this.transformAdditionalProperties), find(propEq(instrumentType, 'paymentInstrumentTypeCode')), propOr(false, 'requirePhoneNumber'))(_this.state.paymentInstrumentConfiguration);
      };
      this.handleChangeDropDownAddress = function () {
        _this.loadingIndicator = true;
        if (!addressStateRegionProvinceValueOptionsForCountry(_this.state.makePaymentAddress.Country, _this.state.addressCountriesAll, _this.state.addressStatesAll)) {
          _this.resetStateFlag = false;
        }
        _this.actions.setMakePaymentInstrumentBillingAddress(clone(_this.state.makePaymentAddress));
        _this.editPaymentInstrument.BillingAddress = clone(_this.state.makePaymentAddress);
        _this.actions.setMakePaymentInstrument(_this.editPaymentInstrument);
        _this.updateStateField();
        _this.updateAddressFormModel();
        _this.loadingIndicator = false;
      };
      this.handlePaymentTypeChange = function (selectedPaymentTypeOption) {
        _this.savePaymentInstrument = true;
        _this.renderAddress = false;
        _this.$timeout(function () {
          _this.renderAddress = true;
        });
        _this.resetForm();
        if (selectedPaymentTypeOption && selectedPaymentTypeOption.paymentInstrumentType) {
          _this.editPaymentInstrument.Type = selectedPaymentTypeOption.paymentInstrumentType.Value;
        }
        _this.updatePaymentInstrumentEditCopy();
      };

      //This function is called by the child select-or-text-input component as a callback.
      //If the resetStateFlag is set as false by the handleChangeDropDownAddress function, then we need to set it back to true (as resetting the state should be the default), but then return false to the child controller.
      //Because we normally want to reset the state on the change of a country, to a country with a dropdown, this pattern was needed when preventing that state reset on a change of the overall address dropdown.
      //This pattern is also designed to avoid race conditions or the need of a $timeout function
      this.shouldResetState = function () {
        if (!_this.resetStateFlag) {
          _this.resetStateFlag = true;
          return false;
        } else {
          return true;
        }
      };
      this.updateStateField = function () {
        _this.actions.setAddressData(_this.editPaymentInstrument.BillingAddress);
        _this.stateRequired = stateRequiredHelper(_this.state.addressRequirements, _this.state.addressStatesOptions);

        // if Country has states, reset State if it's not one of them
        if (_this.state.addressStatesOptions && !_this.state.addressStatesOptions.find(function (stateOption) {
          return stateOption.value === _this.editPaymentInstrument.BillingAddress.State;
        })) {
          _this.editPaymentInstrument.BillingAddress.State = null;
          _this.actions.setMakePaymentAddressStateValue(null);
          _this.addressFormModel.stateRegionProvince = _this.editPaymentInstrument.BillingAddress.State;
        }
        _this.canEditAddress();
      };
      this.canEditAddress = function () {
        _this.isAddressLocked = _this.state.makePaymentAddress && _this.state.makePaymentAddress.Locked;
      };
      this.handleChangeFormCountry = function () {
        _this.updateStateField();
      };
      this.closeNewEditPaymentMethodPopup = function () {
        _this.renderAddress = false;
        _this.resetForm();
        _this.onClose()();
      };
      this.getDialogTextKeys = function () {
        return _this.dialogTextKeys[_this.isEditingPaymentInstrument ? 'edit' : 'new'];
      };
      this.showRecordPaymentInstrumentBox = function () {
        return !_this.isEditingPaymentInstrument && _this.showSavePaymentInstrument && (_this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.E_CHECK || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL || _this.editPaymentInstrument.Type === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD);
      };
      this.updatePaymentInstrumentEditCopy = function (changes) {
        if (isNil(changes) || changes === _this.CHANGE_CARD_TYPE) {
          _this.actions.setMakePaymentInstrument(clone(_this.editPaymentInstrument));
        }
        _this.editPaymentInstrument = _this.state.newPaymentMethodWithMetadata;
        _this.updateAddressFormModel();
      };
      this.updatePaymentInstrumentOnBlur = function () {
        _this.updatePaymentInstrumentEditCopy();
      };
      this.initialized = true;
      if (this.paymentInstrument || this.showPaymentInstrumentForm) {
        this.editPaymentInstrument = clone(this.paymentInstrument);
        this.updatePaymentInstrument(this.editPaymentInstrument);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changes) {
      // Refresh the form if the selected payment instrument changes or if the modal is opened.
      if (this.initialized && (changes.paymentInstrument || changes.showPaymentInstrumentForm && changes.showPaymentInstrumentForm.currentValue)) {
        this.editPaymentInstrument = changes.paymentInstrument ? clone(changes.paymentInstrument.currentValue) : clone(this.paymentInstrument);
        this.updatePaymentInstrument(this.editPaymentInstrument);
      }
    }
  }, {
    key: "updatePaymentInstrument",
    value: function updatePaymentInstrument(editPaymentInstrument) {
      if (isNil(editPaymentInstrument) || isNil(editPaymentInstrument.Type) || !this.isEditingPaymentInstrument) {
        this.handlePaymentTypeChange(this.state.paymentInstrumentTypes[0]);
      } else {
        editPaymentInstrument.Type = editPaymentInstrument.Type.toString();
        this.actions.setMakePaymentInstrument(editPaymentInstrument);
      }
      this.updateStateField();
      this.updateAddressFormModel();
      this.renderAddress = true;
    }
  }, {
    key: "onAddressFormChanged",
    value: function onAddressFormChanged(addressFormModel) {
      this.addressFormModel.addressLine1 = addressFormModel.addressLine1;
      this.addressFormModel.addressLine2 = addressFormModel.addressLine2;
      this.addressFormModel.city = addressFormModel.city;
      this.addressFormModel.country = addressFormModel.country;
      this.addressFormModel.stateRegionProvince = addressFormModel.stateRegionProvince;
      this.addressFormModel.postalCode = addressFormModel.postalCode ? addressFormModel.postalCode : null;
      this.addressFormModel.shipToName = addressFormModel.shipToName;
      this.editPaymentInstrument.BillingAddress.ShipToName = this.addressFormModel.shipToName;
      this.editPaymentInstrument.BillingAddress.LineOne = this.addressFormModel.addressLine1;
      this.editPaymentInstrument.BillingAddress.LineTwo = this.addressFormModel.addressLine2;
      this.editPaymentInstrument.BillingAddress.City = this.addressFormModel.city;
      this.editPaymentInstrument.BillingAddress.State = this.addressFormModel.stateRegionProvince;
      this.editPaymentInstrument.BillingAddress.PostalCode = this.addressFormModel.postalCode ? this.addressFormModel.postalCode : null;
      if (addressFormModel.country !== this.editPaymentInstrument.BillingAddress.Country) {
        this.editPaymentInstrument.BillingAddress.Country = addressFormModel.country;
        this.handleChangeFormCountry();
      } else {
        this.updatePaymentInstrumentEditCopy();
      }
    }
  }, {
    key: "updateAddressFormModel",
    value: function updateAddressFormModel() {
      if (!this.editPaymentInstrument || !this.editPaymentInstrument.BillingAddress) {
        return;
      }
      this.addressFormModel = Object.assign({}, this.addressFormModel, {
        addressLine1: this.editPaymentInstrument.BillingAddress.LineOne,
        addressLine2: this.editPaymentInstrument.BillingAddress.LineTwo,
        city: this.editPaymentInstrument.BillingAddress.City,
        country: this.editPaymentInstrument.BillingAddress.Country,
        postalCode: this.editPaymentInstrument.BillingAddress.PostalCode,
        shipToName: this.editPaymentInstrument.BillingAddress.ShipToName,
        stateRegionProvince: this.editPaymentInstrument.BillingAddress.State
      });
    }

    //check if this works
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI(addressKey) {
      //TO-DO verify the appropriate address type below
      var unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true,
          DefaultPostal: true,
          DefaultService: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }]);
}();
export default {
  template: require('./modify.payment.method.popup.html'),
  controller: ModifyPaymentMethodPopupController,
  controllerAs: 'modifyPaymentMethodPopup',
  bindings: {
    filterAutopay: '<?',
    isEditingPaymentInstrument: '<',
    onClose: '&',
    onSuccess: '&',
    paymentInstrument: '<',
    showPaymentInstrumentForm: '<',
    showSavePaymentInstrument: '<?'
  }
};